// extracted by mini-css-extract-plugin
export default {"button":"Button_button__gBJnY","result":"Button_result__ApGLn"};